import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PershingModalService } from '../services/pershing-modal.service';

@Component({
    selector: 'pershing-confirmation-modal',
    templateUrl: 'pershing-confirmation-modal.component.html'
})

export class PershingConfirmationModalComponent implements OnInit, OnDestroy {

    displayMessage: string;

    constructor(private pershingModalService: PershingModalService, @Inject(MAT_DIALOG_DATA) public data) {
        this.displayMessage = data;
    }

    ngOnInit(): void {

    }

    setConfirmationModalValue(value: boolean): void {
        this.pershingModalService.setConfirmationModal(value);
        this.closeDialog();
    }

    closeDialog(): void {
        this.pershingModalService.closePershingModal('ExportMoreModalComponent');
    }

    ngOnDestroy(): void {
        this.pershingModalService.setConfirmationModal(false);
    }
}
